import Heading from './Heading';
export default Heading;
//# sourceMappingURL=index.js.map